import connectGetter from './connectGetter';

const AGENT = 'agent';

export default function getContactConnection(contact?: connect.Contact): connect.BaseConnection | undefined {
  return connectGetter(contact, 'getConnections')?.find((connection) => connectGetter(connection, 'getType') !== AGENT);
}
